import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Button} from 'shells/button/button';
import {Link} from 'shells/link/link';
import {MessageGroup} from 'shells/message-group/message-group';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';
import {ModalTitle} from 'shells/typography/modal-title';

import CompleteSVG from './assets/complete.svg';
import {trackModalPageLoad} from './track-page-load';

type Props = {
    nextPage: string;
    doneNoSyncPage: string;
    onClose: () => void;
    currentUrl: string;
};

export function SuccessfulSyncableConnection(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    React.useEffect(() => {
        window.dispatchEvent(new Event('onboarding-step-completed-email-calendar-sync'));
    }, []);

    const maybeLaterComponent = NutClientConfig.hasImprovedEmailCalendarSyncFF ? (
        // @ts-expect-error
        <Link variant='secondary' size='small' as={RoutedLink} to={props.doneNoSyncPage}>
            Maybe later
        </Link>
    ) : (
        <Button variant='text' onClick={props.onClose}>
            Maybe later
        </Button>
    );

    return (
        <RightFrame>
            <ModalMain>
                <SpacerGroup mb={32}>
                    <MessageGroup
                        title='Great, you’re connected!'
                        text='You can now send emails from inside of Nutshell using your own email address.'
                        // We don't actually want to set a size, just use the native svg's size
                        icon={() => <CompleteSVG />}
                    />
                </SpacerGroup>
                <ModalHeader>Do you want to sync your email?</ModalHeader>
                <ModalSubheader>
                    Connect your email to Nutshell so that email conversations never slip through
                    the cracks.
                </ModalSubheader>
                <ModalTitle>Sync your emails with Nutshell</ModalTitle>
                <BulletedList
                    bullets={[
                        'Share your emails with your team (if you want to!)',
                        'Get a head start by automatically creating Nutshell People from your recent email conversations',
                        'Automate follow-up conversations and detect reply rates to see how effective your outreach is',
                    ]}
                />
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    {maybeLaterComponent}
                    {/* @ts-expect-error */}
                    <Link variant='button-primary' size='big' as={RoutedLink} to={props.nextPage}>
                        Yes, sync my email
                    </Link>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
